import { Component } from '@angular/core';

@Component({
  selector: 'neq-menu',
  templateUrl: './menu.component.html'
})
export class NeqMenuComponent {}
